import React from 'react';

import { SvgIconProps } from '@ui-core/types';

import BaseIcon from '../base-icon';

const SvgIcon: React.FC<SvgIconProps> = (props: SvgIconProps) => {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9988 8.0022C12.5508 8.0022 12.9988 8.4492 12.9988 9.0022V13.0022C12.9988 13.5542 12.5508 14.0022 11.9988 14.0022C11.4458 14.0022 10.9988 13.5542 10.9988 13.0022V9.0022C10.9988 8.4492 11.4458 8.0022 11.9988 8.0022Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9988 15.7522C12.6888 15.7522 13.2488 16.3122 13.2488 17.0022C13.2488 17.6922 12.6888 18.2522 11.9988 18.2522C11.3088 18.2522 10.7488 17.6922 10.7488 17.0022C10.7488 16.3122 11.3088 15.7522 11.9988 15.7522Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9997 2C11.4977 2 10.9957 2.25 10.7167 2.752L1.1867 19.829C0.643703 20.804 1.3517 22 2.4707 22H21.5297C22.6487 22 23.3557 20.804 22.8127 19.829L13.2837 2.752C13.0037 2.25 12.5017 2 11.9997 2ZM11.9997 4.554L20.6237 20.008H3.3767L11.9997 4.554Z"
      />
    </BaseIcon>
  );
};

export default SvgIcon;
